import { render, staticRenderFns } from "./BrandReviews.vue?vue&type=template&id=397b4bee&scoped=true"
import script from "./BrandReviews.vue?vue&type=script&lang=js"
export * from "./BrandReviews.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./BrandReviews.vue?vue&type=style&index=1&id=397b4bee&prod&scoped=true&lang=css"
import style2 from "./BrandReviews.vue?vue&type=style&index=2&id=397b4bee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397b4bee",
  null
  
)

export default component.exports